import React from "react";
import Matrix from "components/widget/Matrix";

const Lineage = ({recordData, gender, type='image', ...props}) => {
	console.log(gender);
	return (
		<div className="lineage">
			<Matrix recordData={recordData} gender={gender?.toLowerCase()} type={type} animalType={recordData?.type_id}/>

			<div className="parent-wrapper flex flex-col">
				{recordData?.sire && 
					<Lineage recordData={recordData.sire} gender="male" type={type} animalType={recordData.type_id}/>
				}
				{recordData?.dam && 
					<Lineage recordData={recordData.dam} gender="female" type={type} animalType={recordData.type_id}/>
				}
			</div>
		</div>
    );
};

export default Lineage;